import { fetchWrapper } from "../utils/apiFetch";

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://pro.mokshiq.in";

export const ReportService = {
  // Day-wise user service summary & detail records
  getDayWiseReport: async ({ userId, startDate, endDate, service = "", page = 1, pageSize = 50 }) => {
    let url = `${API_BASE_URL}/day_wise_user_report?user=${userId}&filter_date=${startDate}&end_date=${endDate}`;
    if (service) url += `&service=${service}`;
    // Pagination parameters if supported by backend
    // url += `&page=${page}&page_size=${pageSize}`;
    
    // fetchWrapper automatically attaches 'Authorization: Bearer <authToken>'
    const response = await fetchWrapper(url);
    return response;
  },

  // Fund movement summary (credit/debit, wallet loads, transfers)
  getFundSummaryReport: async ({ userId, startDate, endDate, memberId = "", page = 1, pageSize = 50 }) => {
    let url = `${API_BASE_URL}/fund_summary_report?user=${userId}&filter_date=${startDate}&end_date=${endDate}`;
    if (memberId) url += `&member_id=${memberId}`;
    
    const response = await fetchWrapper(url);
    return response;
  },

  // Service-specific receipts
  getReceiptDetails: async (type, refId) => {
    const endpointMap = {
      recharge: `/show_receipt_recharge_refid?ref_id=${refId}`,
      bbps: `/show_receipt_bbps?id=${refId}`,
      aeps: `/show_receipt_aeps?id=${refId}`,
      dmt: `/show_receipt_dmt?id=${refId}`,
      payout: `/show_payout_receipt?id=${refId}`,
    };
    
    const path = endpointMap[type] || `/show_receipt_recharge_refid?ref_id=${refId}`;
    const url = `${API_BASE_URL}${path}`;
    
    const response = await fetchWrapper(url);
    return response;
  },
};
